import { useState } from "react";
import type { StudentStatus } from "../../api/students";
import "./StudentStatusSelect.css";

export const STUDENT_STATUS_LABELS: Record<StudentStatus, string> = {
  active: "Aktif",
  passive: "Pasif",
  graduated: "Mezun",
};

const STATUS_OPTIONS: StudentStatus[] = ["active", "passive", "graduated"];

type Props = {
  value: StudentStatus;
  disabled?: boolean;
  onChange: (status: StudentStatus) => void | Promise<void>;
};

export function StudentStatusSelect({ value, disabled, onChange }: Props) {
  const [busy, setBusy] = useState(false);

  const handleChange = async (next: StudentStatus) => {
    if (next === value || disabled || busy) return;
    setBusy(true);
    try {
      await onChange(next);
    } finally {
      setBusy(false);
    }
  };

  return (
    <select
      className={`kp-stu-status kp-stu-status--${value}${busy ? " kp-stu-status--busy" : ""}`}
      value={value}
      disabled={disabled || busy}
      aria-label="Kursiyer durumu"
      onChange={(e) => {
        void handleChange(e.target.value as StudentStatus);
      }}
    >
      {STATUS_OPTIONS.map((status) => (
        <option key={status} value={status}>
          {STUDENT_STATUS_LABELS[status]}
        </option>
      ))}
    </select>
  );
}
